import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RatingsActions from '../actions/RatingsActions';
import ShelfActions from '../actions/ShelfActions';
import { getShelvesForCurrentUser } from '../selectors/ShelfSelector';
import { getCurrentUserRatings, getRatingsTransactions } from '../selectors/ugc/RatingsSelector';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ItemAddedToShelfView from '../components/shared/ItemAddedToShelfView';
import { SHELF_NAMES } from '../constants/ShelfConstants';

export class AddedToShelfWorkflowContainer extends BcReactComponent {
  componentDidMount() {
    const { ratingsActions, shelfItem, bib } = this.props;
    if (shelfItem.get('shelf') === SHELF_NAMES.COMPLETED) {
      ratingsActions.getItemRatings([bib.get('metadataId')]);
    }
  }

  render() {
    const { id, bib, shelfItem, rating, ratingsTransactions, closeWorkflow, ratingsActions, shelfActions, view } = this.props;

    return (
      <ItemAddedToShelfView
        workflowId={id}
        bib={bib}
        shelfItem={shelfItem}
        currentUserRating={rating}
        ratingsTransactions={ratingsTransactions}
        handleClose={closeWorkflow}
        rateItem={ratingsActions.rateItem}
        changeItemRating={ratingsActions.changeItemRating}
        removeItemRating={ratingsActions.removeItemRating}
        updateShelfItems={shelfActions.updateShelfItems}
        removeShelfItems={shelfActions.removeShelfItems}
        view={view} />
    );
  }
}

AddedToShelfWorkflowContainer.propTypes = {
  id: PropTypes.string,
  metadataId: PropTypes.string,
  bib: ImmutablePropTypes.map,
  shelfItem: ImmutablePropTypes.map,
  rating: ImmutablePropTypes.map,
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  closeWorkflow: PropTypes.func.isRequired,
  ratingsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  view: PropTypes.string,
  existsOnShelf: PropTypes.bool
};

AddedToShelfWorkflowContainer.displayName = 'ItemTransactionWorkflowContainer';

const mapStateToProps = (state, ownProps) => {
  const bib = state.getIn(['entities', 'bibs', ownProps.metadataId, 'briefInfo']);
  const shelfItem = getShelvesForCurrentUser(state).get(ownProps.metadataId);
  const rating = getCurrentUserRatings(state).get(ownProps.metadataId);
  const ratingsTransactions = getRatingsTransactions(state);

  return {
    bib,
    shelfItem,
    rating,
    ratingsTransactions
  };
};

const mapDispatchToProps = dispatch => ({
  ratingsActions: bindActionCreators(RatingsActions, dispatch),
  shelfActions: bindActionCreators(ShelfActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AddedToShelfWorkflowContainer);



// WEBPACK FOOTER //
// ./app/containers/AddedToShelfWorkflowContainer.jsx